import { http } from "../client";
export var updateDevice = function (_a) {
    var id = _a.id, title = _a.title, timetableId = _a.timetableId;
    return http.api.put("devices/".concat(id), {
        title: title,
        timetable_id: timetableId,
    });
};
